/* -----------------Types--------------- */
import { formatDateToLocalizedString } from "@helpers/date";
import type { Plan } from "@memorang/types";

/* -----------------Child components--------------- */
import CustomMarkdownRenderer from "components/CustomMarkdownRenderer";
import { t } from "i18next";

type RecommendedPlanTextProps = {
	recommendedPlan: Plan;
	selectedDate?: string;
};
const RecommendedPlanText = ({
	recommendedPlan,
	selectedDate,
}: RecommendedPlanTextProps) => {
	const text = t("purchase.paywall.recommendedPlan", {
		duration: recommendedPlan.duration,
		interval: t(`common.${recommendedPlan.interval}`),
		dateText: selectedDate
			? `${t("common.on")} **${formatDateToLocalizedString(selectedDate)}**`
			: "",
	});
	return <CustomMarkdownRenderer text={text} textAlign="center" />;
};
export default RecommendedPlanText;
